import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";

export const ActionButton = styled(IconButton)(({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    color: theme.palette.jigsaw.main,
    borderRadius: "8px",
    height: "40px",
    width: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "8px",
    transition: "background 0.2s",
    "&:hover": {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.jigsaw.blue,
    },
}));

export const SpacingPlaceholder = styled("div")(() => ({
    width: "40px",
    height: "40px",
    display: "inline-block",
    marginLeft: "8px",
}));